// extracted by mini-css-extract-plugin
module.exports = {"content":"founding_content__9GHap","title":"founding_title__mFacl"};